import Moment from 'moment'
import {OfferReservationResponseItem} from '@/types/service-response'
import BusinessTimeBlockCollection from "@/model/TimeBlockCollection";

export default class MenuReservationItem {

  private constructor (
    readonly acceptanceStatus: any,
    readonly id: number,
    readonly date: Date,
    readonly status: any,
    readonly reservationId: number,
    readonly topMenuGroup: any,
    readonly reservedOfferCollection: any[],
    readonly reservedOffers: any[],
    readonly timeBlock: BusinessTimeBlockCollection,
    readonly business: number,
    readonly boarderNote: string | null
  ) {}

  get isMenuOfferedByDay (): boolean {

    let isOffered = true

    return isOffered
  }

  get dayName (): string {
    const locale =localStorage.getItem('uiLanguageCodeApp') || navigator.language || process.env.VUE_APP_I18N_LOCALE || 'sk'
    const date = Moment(this.date);
    date.locale(locale)
    return date.format("dddd")
  }

  get formatedDate (): string {
    const date = Moment(this.date);
    return date.format("D.M.Y")
  }

  get formatedDbDate (): string {
    const date = Moment(this.date);
    return date.format("Y-MM-DD")
  }

  static createFromResponse (responseData: OfferReservationResponseItem): MenuReservationItem {
    return new MenuReservationItem(
      responseData.acceptanceStatus,
      responseData.id,
      Moment(responseData.date).toDate(),
      responseData.status.name,
      responseData.id,
      responseData.topMenuGroup,
      responseData.reservedOfferCollection,
      responseData.reservedOffers,
      BusinessTimeBlockCollection.createFromResponse(responseData.timeBlock),
      responseData.business.id,
      responseData.boarderNote
    )
  }
}
